import {Box} from '@mui/material';
import {BoardView, BoardViewTypeEnum} from 'models/board/boardView.model';
import React from 'react';
import AppKanbanBoard from './KanbanBoardView/AppKanbanBoard';
import {TableBoardView} from './TableBoardView';
import UserTicketAssignmentReportBoardView from './UserTicketAssignmentReport/UserTicketAssignmentReportBoardView';
import {ItemStatus} from 'models/board';

interface Props extends RenderBoardItemCommonTypes {}
export interface RenderBoardItemCommonTypes {
    getAllStatusesLoading: boolean;
    selectedBoardView: BoardView;
    itemStatuses: ItemStatus[];
}

export const RenderBoardViews: React.FC<Props> = ({...rest}) => {
    switch (rest.selectedBoardView.boardViewType) {
        case BoardViewTypeEnum.Kanban:
            return <AppKanbanBoard {...rest} />;
        case BoardViewTypeEnum.TicketUserAssignmentReport:
            return <UserTicketAssignmentReportBoardView />;
        case BoardViewTypeEnum.Table:
            return <TableBoardView {...rest} />;
        case BoardViewTypeEnum.Report:
            return <>report view</>;
        // case BoardViewTypeEnum.Report:
        //     return <>report view</>;
        default:
            return <Box></Box>;
    }
};
